module.exports = __webpack_public_path__ + "static/media/automatedcontent_decorative_section2.1bb22916.png";